import React, { useState } from "react";
import "./style.css";

import { Link, useParams } from "react-router-dom";
import expDataTemplate from "../../utils/expData.template.json";
import axios from "axios";
const GIST_ID = "52552698c6328f5d5fe22567e535dd06";

export default function Test() {
  const { id } = useParams();
  const axiosConfig = {
    method: "get",
    url: `https://api.github.com/gists/${GIST_ID}`,
    headers: {},
  };

  React.useEffect(() => {
    axios(axiosConfig)
      .then((res) => {
        console.log(
          JSON.parse(res.data.files["db.json"].content).expts[Number(id) - 1]
            .test
        );
        setQuestions(
          JSON.parse(res.data.files["db.json"].content).expts[Number(id) - 1]
            .test
        );
      })
      .catch((err) => {
        console.error(err);
      });
    //eslint-disable-next-line
  }, []);
  const [questions, setQuestions] = React.useState(
    expDataTemplate.expts[Number(id) - 1].test
  );

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [showScore, setShowScore] = useState(false);
  const [score, setScore] = useState(0);

  const handleAnswerOptionClick = (questionNumber, index) => {
    if (questions[questionNumber].correctOption === index) {
      setScore(score + 1);
    }

    const nextQuestion = currentQuestion + 1;
    if (nextQuestion < questions.length) {
      setCurrentQuestion(nextQuestion);
    } else {
      setShowScore(true);
    }
  };
  return (
    <div className="test-container">
      <div className="app">
        {showScore ? (
          <>
            <div className="score-section flex flex-col justify-center align-center gap-5">
              You scored {score} out of {questions.length}
              <Link to="/experiments" className="btn btn-info">
                Go to Experiments
              </Link>
            </div>
          </>
        ) : (
          <>
            <div className="question-section">
              <div className="question-count">
                Question {currentQuestion + 1}/{questions.length}
              </div>
              <div className="question-text">
                {questions[currentQuestion].question}
              </div>
            </div>
            <div className="answer-section">
              {questions[currentQuestion].options.map((option, index) => (
                <button
                  className="option-button"
                  key={index}
                  onClick={() =>
                    handleAnswerOptionClick(currentQuestion, index)
                  }
                >
                  {option}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
